module.exports = __webpack_public_path__ + "static/00-ddd63ddc00eb6a183e2d2dc45410cb55.jpg";